export default __webpack_public_path__ + "static/media/AssetStateCountWidget.c2539d62.png";